
export const categoryOptions = [
    { value: 'catch-up', label: 'Catch up' },
    { value: 'create', label: 'Create' },
    { value: 'ask', label: 'Ask' },
    { value: 'understand', label: 'Understand' },
    { value: 'learn', label: 'Learn' },
    { value: 'schedule', label: 'Schedule' },
    { value: 'edit', label: 'Edit' },
    { value: 'prepare', label: 'Prepare' },
    { value: 'analyze', label: 'Analyze' },
    { value: 'code', label: 'Code' },
    { value: 'design', label: 'Design' },
    { value: 'execute', label: 'Execute' },
    { value: 'find', label: 'Find' },
];

export const tagOptions = [
    { value: 'links', label: 'Links' },
    { value: 'reference', label: 'Reference' },
    { value: 'resources', label: 'Resources' },
    { value: 'analysis', label: 'Analysis' },
    { value: 'summary', label: 'Summary' },
    { value: 'text-processing', label: 'Text Processing' },
    { value: 'example', label: 'Example' },
    { value: 'tutorial', label: 'Tutorial' },
    { value: 'usage', label: 'Usage' },
    { value: 'documentation', label: 'Documentation' },
    { value: 'formatting', label: 'Formatting' },
    { value: 'guidelines', label: 'Guidelines' },
    { value: 'best-practices', label: 'Best Practices' },
    { value: 'note', label: 'Note' },
    { value: 'reminder', label: 'Reminder' },
    { value: 'precautions', label: 'Precautions' },
    { value: 'safety', label: 'Safety' },
    { value: 'warning', label: 'Warning' },
    { value: 'optimization', label: 'Optimization' },
    { value: 'performance', label: 'Performance' },
    { value: 'tips', label: 'Tips' },
    { value: 'faq', label: 'FAQ' },
    { value: 'questions', label: 'Questions' },
    { value: 'support', label: 'Support' },
    { value: 'citation', label: 'Citation' },
    { value: 'reading', label: 'Reading' },
    { value: 'code', label: 'Code' },
    { value: 'programming', label: 'Programming' },
    { value: 'inspiration', label: 'Inspiration' },
    { value: 'motivation', label: 'Motivation' },
    { value: 'quote', label: 'Quote' },
    { value: 'checklist', label: 'Checklist' },
    { value: 'planning', label: 'Planning' },
    { value: 'tasks', label: 'Tasks' },
    { value: 'attachment', label: 'Attachment' },
    { value: 'files', label: 'Files' },
    { value: 'supplementary', label: 'Supplementary' },
    { value: 'agenda', label: 'Agenda' },
    { value: 'discussion', label: 'Discussion' },
    { value: 'meeting', label: 'Meeting' },
    { value: 'overview', label: 'Overview' },
];
